 // Contrôles personnalisés des vidéos produit
(function () {
  function initVideo(slide) {
    const video = slide.querySelector('video');
    if (!video) return;

    const playBtn = slide.querySelector('.video-control--play');
    const muteBtn = slide.querySelector('.video-control--mute');
    const fullscreenBtn = slide.querySelector('.video-control--fullscreen');

    const updatePlayState = () => {
      if (!playBtn) return;
      playBtn.dataset.state = video.paused ? 'paused' : 'playing';
    };

    const updateMuteState = () => {
      if (!muteBtn) return;
      muteBtn.dataset.state = video.muted ? 'muted' : 'unmuted';
    };

    if (playBtn) {
      playBtn.addEventListener('click', () => {
        if (video.paused) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', () => {
        video.muted = !video.muted;
        updateMuteState();
      });
    }

    if (fullscreenBtn) {
      fullscreenBtn.addEventListener('click', () => {
        const target = video;
        if (document.fullscreenElement) {
          document.exitFullscreen();
        } else if (target.requestFullscreen) {
          target.requestFullscreen();
        } else if (target.webkitEnterFullscreen) {
          // iOS Safari
          target.webkitEnterFullscreen();
        }
      });
    }

    video.addEventListener('play', updatePlayState);
    video.addEventListener('pause', updatePlayState);
    video.addEventListener('volumechange', updateMuteState);

    updatePlayState();
    updateMuteState();
  }

  function init() {
    document.querySelectorAll('.product__media-wrapper .slide--video').forEach(initVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.product__media-wrapper .slide--video')) {
      init();
    }
  });
})();
